import accountScope from './account';

export default accountScope;
